import React, { useEffect, useState } from "react";
import { FiAlertTriangle, FiAward, FiCheck } from "react-icons/fi";
import { getsurveysPointApi } from "./surveycomplete_api";
import { Link } from "react-router-dom";
import { SurveyOutcomeCard } from "./SurveyOutcomeCard";

function SuccessPopup() {
  const [data] = useState({ rating: 0 });
  const [surveyPoints, setSurveyPoints] = useState<number>(0);
  const [errorMessage] = useState("");
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);

  const fetchPoints = async (sessionId: string, rating: number, uid: string) => {
    const response = await getsurveysPointApi(sessionId, rating, uid);
    if (response.success === true) {
      setSurveyPoints(response.data);

    } else {
      setSurveyPoints(0);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const uidParam = params.get("UID");
    const sessionIdParam = params.get("SESSION_ID");
    if (sessionIdParam) fetchPoints(sessionIdParam, data.rating, uidParam);
  }, []);

  return (
    <SurveyOutcomeCard
      tone="success"
      icon={FiCheck}
      title="Congratulations!"
      actions={
        <Link to="/my-surveys" className="block">
          <div className="flex justify-center">
            <button className="zs-btn zs-btn-primary zs-btn-lg zs-btn-block">
              Browse My Surveys
            </button>
          </div>
        </Link>
      }
    >
      {/* Reward Section */}
      <p className="text-ink-2">
        You&apos;ve completed the survey and earned{" "}
        <span className="font-semibold text-ink">{`${surveyPoints}`} Points</span>
      </p>
      <div className="mx-auto inline-flex items-center gap-2 rounded-lg border border-success/20 bg-success-soft px-4 py-2.5">
        <FiAward className="h-5 w-5 text-success" aria-hidden="true" />
        <span className="font-display text-2xl font-bold tabular-nums text-ink">+{surveyPoints}</span>
        <span className="text-sm font-medium text-ink-3">points</span>
      </div>

      {/* Error Modal */}
      {isErrorModalOpen && (
        <div className="zs-backdrop" role="alertdialog" aria-modal="true">
          <div className="zs-modal max-w-sm p-6 text-center">
            <span className="mx-auto inline-flex h-11 w-11 items-center justify-center rounded-full bg-danger-soft text-danger">
              <FiAlertTriangle className="h-5 w-5" aria-hidden="true" />
            </span>
            <h2 className="mt-4 font-display text-lg font-bold text-ink">Error</h2>
            <p className="mt-2 text-sm text-ink-3">
              {errorMessage && <span>{errorMessage}</span>}
            </p>
            <button
              onClick={() => setIsErrorModalOpen(false)}
              className="mt-6 zs-btn zs-btn-primary zs-btn-block"
            >
              OK
            </button>
          </div>
        </div>
      )}
    </SurveyOutcomeCard>
  );
}

export default SuccessPopup;
